module.exports = __webpack_public_path__ + "img/low-cost-first.d48fe43e.svg";